<nz-layout>
  <nz-header>
    <app-header></app-header>
  </nz-header>
  <!-- <nz-spin [nzSpinning]="isSpinning" nzSize="large"> -->
  <nz-content class="inner-content">
    <router-outlet></router-outlet>
  </nz-content>
  <!-- </nz-spin> -->
  <nz-footer>
    <div>
      <span>©2025 TeamSystem S.p.A.</span>
      <span> | </span>
      <a
        href="https://tc.teamsystem.com/InformativaprivacySPID.pdf"
        target="_blank"
      >
        <span class="infoHref"> Privacy Policy </span>
      </a>
      <span> – </span>
      <a href="https://tc.teamsystem.com/CookiePolicySPID.pdf" target="_blank">
        <span class="infoHref"> Cookie </span>
      </a>
      <span> | </span>
      <span>All rights reserved ({{ version }})</span>
    </div>
  </nz-footer>
</nz-layout>
